//#region src/gql/fragment-masking.ts
function getFragmentData(_documentNode, fragmentType) {
	return fragmentType;
}
function makeFragmentData(data, _fragment) {
	return data;
}
function isFragmentReady(queryNode, fragmentNode, data) {
	const deferredFields = queryNode.__meta__?.deferredFields;
	if (!deferredFields) return true;
	const fragName = fragmentNode.definitions[0]?.name?.value;
	const fields = fragName && deferredFields[fragName] || [];
	return fields.length > 0 && fields.every((field) => data && field in data);
}
//#endregion
export { getFragmentData, isFragmentReady, makeFragmentData };

//# sourceMappingURL=fragment-masking.js.map